import { render, staticRenderFns } from "./SouthAfricaFlag.vue?vue&type=template&id=2cf60b90&"
import script from "./SouthAfricaFlag.vue?vue&type=script&lang=js&"
export * from "./SouthAfricaFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports